<script setup lang="ts">
const props = defineProps<{
  loading?: boolean
  disabled?: boolean
  size?: 'sm' | 'md' | 'lg'
  classes?: string
  type?: 'dark' | 'light' | 'text'
}>()

const base = 'font-bold transition-all'

const types = {
  dark: 'bg-black text-white hover:bg-white hover:text-black border border-black',
  light: 'bg-white text-black',
  text: 'border border-1 border-black',
}

const sizes = {
  sm: '!px-2 text-sm font-semibold',
  md: 'px-8 py-3 text-lg font-bold',
  lg: 'p-5',
}

const cls = computed(() => {
  return `${base} ${types[props.type ?? 'light']} ${sizes[props.size ?? 'md']} ${props.classes ?? ''}`
})
</script>

<template>
  <button :class="[cn(cls), { disabled: props.disabled }]">
    <UiButtonText class="flex items-center gap-2" :loading="props.loading">
      <slot name="icon"></slot>
      <slot />
    </UiButtonText>
  </button>
</template>
